import http from '@/lib/http';
import { Message } from 'element-ui';

export default {

    async getKsList() {
        try {
            let res = await http.get('/api/feeds/departments');
            if (res.success) {
                return res.data;
            } else {
                Message.error(res.message);
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    },

    async getFocusList(pageIndex,pageSize) {
        try {

            let res = await http.get(`/api/feeds/focus?pageIndex=${pageIndex}&pageSize=${pageSize}`);
            if (res.success) {
                return res.data;
            } else {
                Message.error(res.message);
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    },

    async getHotList(pageIndex,pageSize) {
        try {
            let res = await http.get(`/api/feeds/hot?pageIndex=${pageIndex}&pageSize=${pageSize}`);
            if (res.success) {
                return res.data;
            } else {
                Message.error(res.message);
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    },

    async getKsDiscussList(pageIndex, pageSize, departmentId) {
        try {
            let params = {
                pageIndex,
                pageSize,
                departmentId,
            };
            let res = await http.get('/api/feeds/department', {params});
            if (res.success) {
                return res.data;
            } else {
                Message.error(res.message);
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    },

    async addFocusKs(departmentId) {
        try {
            let res = await http.put('/api/feeds/department/focus?departmentId='+departmentId);
            if (res.success) {
                return res.data;
            } else {
                Message.error(res.message);
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    },

    async deleteFocusKs(departmentId) {
        try {
            let res = await http.delete('/api/feeds/department/focus?departmentId='+departmentId);
            if (res.success) {
                return res.data;
            } else {
                Message.error(res.message);
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    },
}
